export const MIN_DESKTOP_WIDTH = "1100px"
export const MAX_MOBILE_WIDTH = "1099px"
